
export interface OldPlasticsQualityAlertInspection {
	id: string;
	createdOn: Date;
	createdById: string;
	productVersionId: string;
	qualityAlertId: string;
	moldingTaskId: string;
	passedInspection: boolean;
	imageDownloadUrls: string[];
}

export interface PlasticsQualityAlertInspection {
	id: string;
	createdOn: Date;
	createdById: string;
	productVersionId: string;
	entityId: string;
	qualityAlertId: string;
	taskId: string;
	inspectionType: PlasticsQualityInspectionType;
	status: PlasticsQualityInspectionStatus;
	imageDownloadUrls: string[];
}

export enum PlasticsQualityInspectionStatus {
	Passed = 'Passed',
	Failed = 'Failed',
	NotRunning = 'Not Running'
}

export enum PlasticsQualityInspectionType {
	MATERIAL = 'material',
	MOLD = "mold",
	FINISHING = "finishing",
}